import { IAgendamentoMultiplo, IHorario } from 'Models/docas'

const buscaAgendamentoMultiplo = (
  horario: IHorario,
  agendamentosMultiplos: IAgendamentoMultiplo[],
): IAgendamentoMultiplo | undefined => {
  return agendamentosMultiplos.find(
    (f) => f.motorista === horario.nomeMotorista && f.placa === horario.placa,
  )
}

export default buscaAgendamentoMultiplo
